import React from "react";
import { Container, Row, Col, Button } from "reactstrap";

export function NotFound(props) {
    return (
        <Container style={{ marginTop: "15%" }}>
            <Row>
                <Col style={{ textAlign: "center" }}>
                    <h1>404: Page Not Found</h1>
                </Col>
            </Row>
            <Row style={{ padding: "5px" }}>
                <Col style={{ textAlign: "center" }}>
                    <h6>The page you requested does not exist.</h6>
                </Col>
            </Row>
            <Row style={{ padding: "5px" }}>
                <Col style={{ alignItems: "center", justifyContent: "center", display: "flex" }}>
                    <Button color="primary" onClick={() => props.history.push("/")}>
                        Go Home
                    </Button>
                </Col>
            </Row>
        </Container>
    );
}